import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigSegment as _ConfigSegment} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigSegment';
import contentMap from 'componentLibrary';

export const ConfigSegment = (props) => <_ConfigSegment {...props} {...{contentMap}} />;
export const DynamicSegment = connectWithCore(ConfigSegment);
export default DynamicSegment;
